import './Label.css';
import React, { JSX } from 'react';

type LabelProps = {
  readonly classes?: string;
  readonly children: React.ReactNode;
};

export function Label({ classes = '', children }: LabelProps): JSX.Element {
  return <div className={`label ${classes}`}>{children}</div>;
}
